var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"label":"Text","value":_vm.helpData.text},on:{"input":function($event){return _vm.onChange('text', $event)}}}),_c('v-text-field',{attrs:{"label":"Youtube","value":_vm.helpData.youtubeLink,"rules":_vm.youtubeRule},on:{"change":function($event){return _vm.onChange('youtubeLink', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }